import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatButtonModule} from '@angular/material/button';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { ProfileComponent } from './profile.component';
import { AuthGuard } from '../guards/auth.guard';
import { SaveGuard } from '../guards/save.guard';
import { AvatarModule } from '../components/avatar/avatar.module';
import { ConfirmationDialog } from '../components/confirmation-dialog/confirmation-dialog.component';
import { TextInputDialog } from '../components/text-input-dialog/text-input-dialog.component';
import { HelpTooltipModule } from '../components/helpTooltip/helpTooltip.module';
import { ConfirmationDialogModule } from '../components/confirmation-dialog/confirmation-dialog.module';
import { TextInputDialogModule } from '../components/text-input-dialog/text-input-dialog.module';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatSelectModule,
        AvatarModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        HelpTooltipModule,
        ConfirmationDialogModule,
        TextInputDialogModule,
        RouterModule.forChild([
            {
                path: 'profile',
                canActivate: [AuthGuard],
                canDeactivate: [SaveGuard],
                component: ProfileComponent,
                children: []
            }
        ])
    ],
    declarations: [
        ProfileComponent
    ],
    exports: [
        ProfileComponent
    ]
})
export class ProfileModule { }
